
import { useEffect, useRef } from 'react';
import SuccessStoryCard from '../personas/ta-leaders/success-stories/SuccessStoryCard';
import CompaniesTicker from './CompaniesTicker';

const successStories = [
  {
    logo: "/lovable-uploads/Fractal.png",
    highlight: "Made 12 offers in 2 months",
    description: "Staffed a critical client project within timelines"
  },
  {
    logo: "/lovable-uploads/StepSecurity.png",
    highlight: "Hired first candidate sourced on day 2",
    description: "Saved ₹2 Lakhs in agency fees"
  },
  {
    logo: "/lovable-uploads/Callhub.png",
    highlight: "Found a hidden candidate due to AI interviews",
    description: "At 40% of expected CTC"
  }
];

const SuccessStoriesSection = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="bg-white py-20 fade-in-section">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-cs-dark-grey mb-4">
            10,000+ offers made on Cutshort by
          </h2>
          <p className="text-xl text-cs-medium-grey">
            Freed up recruiting teams to focus on <span className="underline decoration-brand-blue decoration-2 underline-offset-4">real recruiting</span>
          </p>
        </div>

        {/* Companies Ticker */}
        <div className="mb-8">
          <CompaniesTicker />
        </div>
      </div>
    </section>
  );
};

export default SuccessStoriesSection;
